module.exports = __webpack_public_path__ + "img/arrow-up.6901fd9b.svg";